import React from 'react'
import Clients from '../Clients'
import CoreValues from '../CoreValues'
import Pillars from '../Pillars'
import SkillSection from '../SkillSection';
import IndustrySlideShow from '../IndustrySlideShow';
import TestimonialContainer from '../TestimonialContainer';
import VideoComponent from '../../components/VideoComponent';
import HomeDashboard from '../HomeDashboard';
import style from './Home.module.css';
import TopTalentCard from '../../components/TopTalentCard';
import NufolksTeam from "../NufolksTeam/index.jsx";

function Home() {
    return (
        <div>
            <HomeDashboard />
            <Clients headingText="Empowering Our Clients with Top Talent" subText="" />
            <CoreValues />
            <TestimonialContainer heading="What Our Clients Say About Us" isSubHeading={false} subheading="" isEmployeeTestimonial={false}  />
            <Pillars />
            <div className={style.video_container}>
                <VideoComponent heading="Experience Our Culture" content="Get a glimpse into our vibrant workplace! Watch our cultural video to see how we collaborate, innovate, and celebrate as a team." />
            </div>
            <SkillSection allowOuterShadow={false} />
            <IndustrySlideShow />
            <div style={{backgroundColor: "white", height: "4rem"}}></div>
            <NufolksTeam />
            <div className={style.TopTalent_outer_Container}>
                <TopTalentCard heading="Let’s Build Careers, Together" content="Looking for growth-driven opportunities or the right talent to elevate your team? Drop your CV or hire top-notch talent today." cardBGColor="rgb(250 236 222)" hColor="black" pColor= "#12151D" />
            </div> 
        </div>
    )
}

export default Home